import { useEffect, useState } from 'react';

export const ROLE_WORKER = 'isWorker';
export const ROLE_EMPLOYER = 'isEmployer';

export const isSameAuth = (prev, next) => {
  return prev.auth.currentUser === next.auth.currentUser;
};

export const useUserWithRole = (auth) => {
  const [userWithRole, setUserWithRole] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    return auth.onAuthStateChanged(async (user) => {
      if (user) {
        setLoading(true);
        try {
          const idTokenResult = await user.getIdTokenResult();
          setUserWithRole({ ...user, claims: idTokenResult.claims });
          setLoading(false);
          setError(undefined);
        } catch (e) {
          setError(e);
          setLoading(false);
        }
      } else {
        setUserWithRole(undefined);
        setLoading(false);
      }
    });
  }, [auth]);

  return [userWithRole, loading, error];
};
